import React from 'react'
import { CheckCircle, Clock, AlertCircle, Loader2, RefreshCw } from 'lucide-react'
import { Contact } from '../stores/userStore'

interface ContactChartStatusProps {
  contact: Contact
  onRetry?: (contactId: string) => void
}

const ContactChartStatus: React.FC<ContactChartStatusProps> = ({ contact, onRetry }) => {
  const getStatusIcon = () => {
    switch (contact.chartStatus) {
      case 'completed':
        return <CheckCircle className="w-4 h-4 text-green-500" />
      case 'importing':
        return <Loader2 className="w-4 h-4 text-blue-500 animate-spin" />
      case 'failed':
        return <AlertCircle className="w-4 h-4 text-red-500" />
      case 'pending':
      default:
        return <Clock className="w-4 h-4 text-gray-400" />
    }
  }

  const getStatusText = () => {
    switch (contact.chartStatus) {
      case 'completed':
        return 'Charts imported'
      case 'importing':
        return 'Importing charts...'
      case 'failed':
        return 'Import failed'
      case 'pending':
      default:
        return 'Pending import'
    }
  }

  const getStatusColor = () => {
    switch (contact.chartStatus) {
      case 'completed':
        return 'text-green-600'
      case 'importing':
        return 'text-blue-600'
      case 'failed':
        return 'text-red-600'
      case 'pending':
      default:
        return 'text-gray-500'
    }
  }

  if (!contact.birthData) {
    return null
  }

  return (
    <div className="flex items-center gap-2 text-sm">
      {getStatusIcon()}
      <span className={getStatusColor()}>
        {getStatusText()}
      </span>
      {contact.chartStatus === 'failed' && onRetry && (
        <button
          onClick={() => onRetry(contact.id)}
          className="ml-2 p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
          title="Retry import"
        >
          <RefreshCw className="w-3 h-3 text-red-500" />
        </button>
      )}
    </div>
  )
}

export default ContactChartStatus 